/* eslint-disable no-undef */

// 谷歌分析脚本
export function googleAnalytics() {
  // return `
  if (
    location.pathname.indexOf('solution-new/tc-video') === -1
    || location.pathname.indexOf('solution-new/beacon-iframe') === -1
  ) {
    if (/tencentcloud/.test(window.location.host)) {
      const gtagScript = document.createElement('script');
      gtagScript.src = '//www.googletagmanager.com/gtag/js?id=G-H9N3R1037X';
      document.head.appendChild(gtagScript);
      window.dataLayer = window.dataLayer || [];
      function gtag() {
        dataLayer.push(arguments);
      }
      gtag('js', new Date());

      let uin = '';
      const uinCookie = document.cookie.match(/uin=.*?;/);
      if (uinCookie) {
        uin = uinCookie[0].split('=')[1].replace(/[o;]/g, '');
        gtag('config', 'G-H9N3R1037X', {
          user_id: uin,
        });
      } else {
        gtag('config', 'G-H9N3R1037X');
      }
    } else {
      (function (i, s, o, g, r, a, m) {
        i.GoogleAnalyticsObject = r;
        (i[r] =          i[r]
          || function () {
            (i[r].q = i[r].q || []).push(arguments);
          }),
        (i[r].l = 1 * new Date());
        (a = s.createElement(o)), (m = s.getElementsByTagName(o)[0]);
        a.async = 1;
        a.src = g;
        m.parentNode.insertBefore(a, m);
      }(window, document, 'script', '//www.google-analytics.com/analytics.js', 'ga'));

      ga('create', 'UA-104377279-1', 'auto');
      ga('send', 'pageview');
    }
  }
  // `;
}

// GTM
export function googleTagManager() {
  // return `
  if (location.pathname.indexOf('solution-new/tc-video') === -1) {
    if (/tencentcloud/.test(window.location.host)) {
      (function (w, d, s, l, i) {
        w[l] = w[l] || [];
        w[l].push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' });
        const f = d.getElementsByTagName(s)[0];
        const j = d.createElement(s);
        const dl = l != 'dataLayer' ? `&l=${l}` : '';
        j.async = true;
        j.src = `https://www.googletagmanager.com/gtm.js?id=${i}${dl}`;
        f.parentNode.insertBefore(j, f);
      }(window, document, 'script', 'dataLayer', 'GTM-TS8W4TV'));
    } else {
      (function (w, d, s, l, i) {
        w[l] = w[l] || [];
        w[l].push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' });
        const f = d.getElementsByTagName(s)[0];
        const j = d.createElement(s);
        const dl = l != 'dataLayer' ? `&l=${l}` : '';
        j.async = true;
        j.src = `//www.googletagmanager.com/gtm.js?id=${i}${dl}`;
        f.parentNode.insertBefore(j, f);
      }(window, document, 'script', 'dataLayer', 'GTM-TJWSQN5'));
    }
  }
  // `;
}

export function logAnalysis() {
  googleAnalytics();
  googleTagManager();
}

/**
 * 日志分析，安装相关脚本
 * @returns {JSX.Element}
 * @constructor
 */
// function LogAnalysis() {
//   const logScriptList = [googleAnalytics(), googleTagManager()];
//   const logScriptHTML = logScriptList.join(';'); // 自执行代码用";"分隔
//   return (
//     <script
//       dangerouslySetInnerHTML={{
//         __html: logScriptHTML,
//       }}
//     />
//   );
// }

// export default LogAnalysis;
